import React from 'react';

export const DataContext = React.createContext<any | null>(null);
